import React from 'react';
import {
  
 InterMilan,
 Juventus,
 ACMilan,
 ASRoma,
 Napoli,
 Lazio,
 Fiorentina,
 Torino,
 Genoa,
 Bologna,
 Cagliari,
 Verona,
 Sampdoria,
 

} from "../clubs";

const SerieA = () => {
  return (
    <div>
      <h1>Dates of the last league titles for each club that has won Serie A.</h1>
      <Napoli />
      <InterMilan />
      <ACMilan />
      <Juventus />
      <ASRoma />
      <Lazio />
      <Sampdoria />
      <Verona />
      <Torino />
      <Cagliari />
      <Fiorentina />
      <Bologna />
      <Genoa />
     
      
      
      

    </div>
  )
}

export default SerieA